import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Globe, Camera, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function Sellers() {
  return <div className="w-full bg-sand min-h-screen pt-24" data-id="element-526">
      {/* Hero */}
      <section className="py-20 px-4 text-center max-w-4xl mx-auto" data-id="element-527">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-6xl font-serif text-navy mb-6" data-id="element-528">
          Elevate Your Listing
        </motion.h1>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl font-light text-navy/70 leading-relaxed" data-id="element-529">
          We don't just list properties; we market lifestyles. Our approach
          ensures your Cabo home reaches the right buyers across the globe with
          unmatched presentation.
        </motion.p>
      </section>

      {/* Value Prop */}
      <section className="py-20 bg-white" data-id="element-530">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-531">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-532">
            <motion.div {...fadeIn} transition={{
            delay: 0.1
          }} className="p-8 border border-navy/10 hover:border-gold transition-colors" data-id="element-533">
              <Globe className="text-gold mb-6" size={32} data-id="element-534" />
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-535">
                Global Reach
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-536">
                Targeted marketing campaigns reaching high-net-worth individuals
                in key feeder markets: California, Texas, Utah, and Western
                Canada.
              </p>
            </motion.div>
            <motion.div {...fadeIn} transition={{
            delay: 0.2
          }} className="p-8 border border-navy/10 hover:border-gold transition-colors" data-id="element-537">
              <Camera className="text-gold mb-6" size={32} data-id="element-538" />
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-539">
                Editorial Presentation
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-540">
                Magazine-quality photography, cinematic video tours, and
                compelling copywriting that tells the unique story of your
                property.
              </p>
            </motion.div>
            <motion.div {...fadeIn} transition={{
            delay: 0.3
          }} className="p-8 border border-navy/10 hover:border-gold transition-colors" data-id="element-541">
              <TrendingUp className="text-gold mb-6" size={32} data-id="element-542" />
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-543">
                Data-Driven Pricing
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-544">
                In-depth market analysis to position your property perfectly,
                maximizing your return while minimizing time on market.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-navy text-sand text-center" data-id="element-545">
        <div className="max-w-3xl mx-auto px-4" data-id="element-546">
          <motion.div {...fadeIn} data-id="element-547">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-548">
              Ready to discover your property's true value?
            </h2>
            <p className="text-sand/70 font-light text-lg mb-10" data-id="element-549">
              Connect with us for a confidential, no-obligation market analysis
              of your Cabo property.
            </p>
            <Link to="/contact" className="inline-flex items-center bg-gold text-white px-8 py-4 uppercase tracking-wider text-sm font-medium hover:bg-gold-dark transition-colors" data-id="element-550">
              Request Market Analysis
              <ArrowRight className="ml-2" size={18} data-id="element-551" />
            </Link>
          </motion.div>
        </div>
      </section>
    </div>;
}